/**
 * 列表/内容页的统一页头。
 *
 * 管理端此前每个页面都内联一段 `<div><h1 className="text-xl …">`，标题字号一致但
 * 与操作按钮的对齐方式、上下留白各不相同（有的 `mt-1`、有的没有）。统一到这里。
 */
import type { ReactNode } from 'react'

export function PageHeader({ title, actions }: { title: string; actions?: ReactNode }) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-4">
      <h1 className="text-xl font-semibold tracking-tight">{title}</h1>
      {actions ? <div className="flex flex-wrap items-center gap-2">{actions}</div> : null}
    </div>
  )
}
